import React, { useContext, useEffect } from 'react'
import { ModalContext } from '../contexts/ModalContext'
import { VideoPlayerContext } from '../contexts/VideoPlayerContext';

import './../scss/Overlay.scss'
import { set } from 'date-fns';

function Overlay() {
    const {isModalActive, setIsModalActive} = useContext(ModalContext);
    const {videoPlayer} = useContext(VideoPlayerContext)
    
    
    const toogleModal = () => {
        setIsModalActive(!isModalActive)
        if (videoPlayer !== null) videoPlayer.pause()
    }

    const handleKeyDown = e => {
        if (e.key === 'Escape') toogleModal()
    }

    useEffect(() => {
        const body = document.querySelector('body')
        const bodyElClassList = body.classList;
        const contentWrapperEl = document.querySelector('.content-wrapper');
        const contentWrapperElClassList = (document.querySelector('.content-wrapper')) ? document.querySelector('.content-wrapper').classList : null;
        
        if (isModalActive) {
            if (!bodyElClassList.contains('no-scroll')) bodyElClassList.add('no-scroll');
            if (contentWrapperElClassList !== null) {
                if (!contentWrapperElClassList.contains('content-wrapper--blur')) contentWrapperElClassList.add('content-wrapper--blur');
                body.addEventListener('keydown', handleKeyDown, {
                    once: true,
                })
            } 
            setTimeout(() => {
                contentWrapperEl.style.overflow = 'hidden'
                contentWrapperEl.setAttribute('aria-hidden', 'true')
                contentWrapperEl.setAttribute('inert', 'true')
                            
            }, 100)  
        } else {
            if (bodyElClassList.contains('no-scroll')) bodyElClassList.remove('no-scroll');
            if (contentWrapperElClassList !== null) {
                if (contentWrapperElClassList.contains('content-wrapper--blur')) contentWrapperElClassList.remove('content-wrapper--blur');
            }
            setTimeout(() => {
                contentWrapperEl.style.overflow = 'auto'
                contentWrapperEl.removeAttribute('aria-hidden')
                contentWrapperEl.removeAttribute('inert')
            }, 100)
        }
    }, [isModalActive])
    

    return (
        <div className={isModalActive ? `overlay overlay--active` : `overlay`} onClick={toogleModal} onKeyDown={handleKeyDown}></div>
    )
}

export default Overlay
